import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { toRef, toValue, type MaybeRefOrGetter } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SiteQueryKeys } from "@/data/api/site-query-keys";
import { SiteProgrammingRangeQueryKeys } from "@/data/api/v4b/site-programming-range/site-programming-range-query-keys";
import { SiteSectionMutationKeys } from "@/data/api/v4b/site-section/site-section-mutation-keys";
import { SiteSectionCategoryId, V4HSiteId } from "@/data/common/ids";

export function useDeleteSectionCategoryMutation(siteId: MaybeRefOrGetter<V4HSiteId>) {
  const v4b = useServices().v4b.clientSdk;
  const queryClient = useQueryClient();
  const _siteId = toRef(siteId);

  return useMutation({
    mutationKey: SiteSectionMutationKeys.deleteCategory(_siteId),
    mutationFn: (categoryId: SiteSectionCategoryId) => {
      return v4b.siteSectionCategory.delete(toValue(siteId), categoryId);
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: SiteQueryKeys.sections(_siteId),
      });

      await queryClient.removeQueries({
        queryKey: SiteProgrammingRangeQueryKeys.findPlanning(_siteId),
      });
    },
    retry: 0,
  });
}
